import {
  IWorkerRootState,
} from '../workerRootState';
import getReducer from './getReducer';

const {
  hasMergeAlreadyBeenComputed,
  reducer,
  updateMergedData,
  getUIState,
  getInputFromURLRouting,
} = getReducer(({rings}: IWorkerRootState) => rings);

export default reducer;

export {
  hasMergeAlreadyBeenComputed,
  updateMergedData,
  getUIState,
  getInputFromURLRouting,
};
